import { jsx as o } from "react/jsx-runtime";
import { f as u, n as p, m as B } from "../../vendor--aJiswR_.js";
import { forwardRef as b } from "react";
import { stupidInvertClasses as $ } from "../../utils/index.js";
import { getButtonStyles as g } from "../BaseButton/index.js";
import { BaseIcon as a } from "../BaseIcon/index.js";
import { isIconName as i } from "../BaseIcon/typeGuards.js";
import { DotProgress as v } from "../DotProgress/index.js";
import { withTooltip as x } from "../Tooltip/withTooltip.js";
import { omitStyleRenderProps as s } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index7.css';const y = "_iconButton_1cuaz_1", I = {
  iconButton: y
}, D = x(
  b(
    ({
      isPendingAriaLabel: d = "Loading...",
      size: r = "md",
      icon: n,
      href: e,
      __inverted: f,
      variant: l = "secondary",
      ...t
    }, c) => {
      const m = u(
        g({
          variant: l,
          size: r,
          ...t
        }),
        I.iconButton,
        f ? $() : void 0
      );
      return typeof e == "string" ? /* @__PURE__ */ o(
        p,
        {
          ...s(t),
          href: e,
          className: m,
          slot: null,
          ref: c,
          children: i(n) && /* @__PURE__ */ o(a, { icon: n, size: r })
        }
      ) : /* @__PURE__ */ o(
        B,
        {
          ...s(t),
          type: "button",
          "data-active": t.isActive ? "true" : void 0,
          className: m,
          ref: c,
          "data-component": "IconButton",
          children: t.isPending ? /* @__PURE__ */ o(v, { "aria-label": d, size: r }) : i(n) && /* @__PURE__ */ o(a, { icon: n, size: r })
        }
      );
    }
  )
);
export {
  D as IconButton
};
//# sourceMappingURL=index.js.map
